const DateFormat = {
    dateAndTimeFormat: function (sDate) {
        if (!sDate) return " - ";
        const dt = new Date(sDate);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }
}

export default DateFormat;